import { render, staticRenderFns } from "./VideoPaused.vue?vue&type=template&id=075a2219&"
import script from "./VideoPaused.vue?vue&type=script&lang=js&"
export * from "./VideoPaused.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports